<template>
  <div :class="[$t('common.fontFamily'), $t('common.lang'), $t('common.type')]">
    <page-navigate></page-navigate>
    <section class="flex items-start dividend_header">
      <div class="dividend_main">
        <h1 class="dividend_title super_large-80_bold md-title-32_bold word2">
          股息调整
        </h1>
        <h2 class="dividend_desc subtitle-20_regular md-body-14_regular word4">
          了解您在指数、ETF与股票差价合约交易中的股息调整和分配机制
        </h2>
        <a :href="signupUrl" target="_blank">
          <div class="dividend_btn primary-default_large cursor-pointer">
            <span class="word5">开始交易</span>
            <span class="iconfont icon-right"></span>
          </div>
        </a>
      </div>
      <img src="@/assets/image/dividend/dividendContainer1Model.png" alt="" class="dividend_model" />
    </section>
    <section class="dividend-adjust">
      <div class="contentBox">
        <div class="dividend-adjust_headerList flex">
          <div class="dividend-adjust_headerItem scroll-fade-left">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
              <rect x="2.5" y="2.5" width="35" height="35" rx="5" stroke="#9F734C" stroke-width="2" />
              <path d="M30 10L10 30" stroke="#9F734C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M25 31.25H31.25" stroke="#A52933" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M25 25H31.25" stroke="#A52933" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M8.75 12.5H16.25" stroke="#A52933" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M12.5 8.75V16.25" stroke="#A52933" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <div class="dividend-adjust_headerTitle title-24_medium md-body-16_medium word6">
              股息调整
            </div>
            <div class="dividend-adjust_headerDesc content-16_regular md-footnote-regular_12 word7">
              股息是上市公司或ETF基金向投资者定期分配的收益，涉及股票、指数及ETF差价合约时，系统将根据实际派息情况对持仓账户进行相应的现金股息调整
            </div>
          </div>
          <div class="dividend-adjust_headerItem scroll-fade-right">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
              <path d="M28.75 20V27.5" stroke="#A52933" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M20 11.25V27.5" stroke="#A52933" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M11.25 15V27.5" stroke="#A52933" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M37.5 15V7.5C37.5 4.73858 35.2614 2.5 32.5 2.5H7.5C4.73858 2.5 2.5 4.73858 2.5 7.5V15"
                stroke="#9F734C" stroke-width="2" stroke-linecap="round" />
              <path d="M37.5 25V32.5C37.5 35.2614 35.2614 37.5 32.5 37.5H7.5C4.73858 37.5 2.5 35.2614 2.5 32.5V25"
                stroke="#9F734C" stroke-width="2" stroke-linecap="round" />
            </svg>
            <div class="dividend-adjust_headerTitle title-24_medium md-body-16_medium word8">
              除息日与交易优化
            </div>
            <div class="dividend-adjust_headerDesc content-16_regular md-footnote-regular_12 word9">
              除息日由指数提供商或ETF、股票公告决定，系统将在当天对多头账户发放现金股息，对空头账户扣除相应金额，提前关注除息安排有助于优化仓位与收益管理
            </div>
          </div>
        </div>
        <h2 class="dividend-adjust_title title-48_bold md-title-24_bold text-center word10 scroll-fade-up">股息调整明细</h2>
        <h3 class="dividend-adjust_desc subtitle-20_regular md-footnote-regular_12 text-center word11 scroll-fade-up">
          差价合约交易中相关产品的股息数据，按多头（买入）股息和空头（卖出）股息分开显示</h3>
        <a :href="signupUrl" target="_blank" class="dividend-adjust_btn mobile scroll-fade-up">
          <div class="primary-default_large word16">开始交易</div>
        </a>
        <div class="dividend-adjust_tableContainer scroll-fade-up">
          <div class="corner-mask mobile"></div>
          <div class="fake-scrollbar mobile">
            <div class="fake-thumb"></div>
          </div>
          <div class="dividend-adjust_table">

            <div class="dividend-adjust_thead body-16_medium md-body-14_medium ">
              <div class="dividend-adjust_th word12">交易产品</div>
              <div class="dividend-adjust_th word13">多头股息</div>
              <div class="dividend-adjust_th word14">空头股息</div>
              <div class="dividend-adjust_th active-product-tab word15">除息日</div>
            </div>
            <div class="dividend-adjust_tbody body-14_regular">
              <template v-for="(item,index) in data">
                <div class="dividend-adjust_td">{{ item.symbol }}</div>
                <div class="dividend-adjust_td">{{ item.long }}</div>
                <div class="dividend-adjust_td">{{ item.short }}</div>
                <div class="dividend-adjust_td body-16_medium dividend-adjust_tdRed">{{item.date}}</div>
                </template>
            </div>
          </div>
        </div>

        <a :href="signupUrl" target="_blank" class="dividend-adjust_btn pc scroll-fade-up">
          <div class="primary-default_large word16">开始交易</div>
        </a>
      </div>
    </section>
    <open-account></open-account>
    <section class="container4 commonQuestion">
      <div class="contentBox">
        <h2 class="word17 scroll-fade-up">常见问题</h2>
        <div class="QA-list">
          <div class="QA-item">
            <div class="QA-title word18">1、什么是股息和除息日？</div>
            <div class="QA-content">
              <p class="QA-li word19">
                股息是上市公司或ETF基金从利润或资产中分配给投资者的资金。除息日是该资产正式派息并调整价格的日期，通常在当天开盘前调整净值或报价。
              </p>
              <p class="QA-li word20">
                在差价合约产品中，无论是指数、ETF
                还是股票类CFD，除息行为都会导致价格调整，因此系统将对持仓客户进行现金补偿或扣款操作
              </p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title word21">2、 股息调整的时间</div>
            <div class="QA-content">
              <p class="QA-li word22">
                指数差价合约股息调整通常会在除息日的00:00-01:00（MT
                时间）反映在您的MT4/MT5交易账号中，并标注为“Dividend”。
              </p>
              <p class="QA-li word23">
                股票及ETF差价合约股息调整通常会在除息日的16:30（MT
                时间）前反映在您的MT5交易账号中，并标注为“Dividend”
              </p>
            </div>
          </div>

          <div class="QA-item">
            <div class="QA-title word24">3、股息对指数交易的影响</div>
            <div class="QA-content">
              <p class="QA-li word25">
                持有多头仓位（买入）：股息调整将存入您的MT4/MT5账号。
              </p>

              <p class="QA-li word26">
                持有空头仓位（卖出）：股息调整将从您的MT4/MT5账号扣除。
              </p>

              <p class="QA-li word27">
                请注意：ETF产品的股息调整也遵循相同原则，依据基金公司公告的派息数据进行调整。
              </p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title word28">4、股息调整的计算公式</div>
            <div class="QA-content">
              <p class="QA-li word29">
                多头仓位（买入）计算公式：手数 × 合约规格 ×
                多头股息金额（按指数计价货币计算）
              </p>

              <p class="QA-li word30">
                空头仓位（卖出）计算公式：手数 × 合约规格 ×
                空头股息金额（按指数计价货币计算）
              </p>
            </div>
          </div>

          <div class="QA-item">
            <div class="QA-title word31">5、股息调整计算示例</div>
            <div class="QA-content">
              <p class="QA-li word32">
                以SPXUSD为例，假设其除息日为2024年10月11日，多头股息金额为
                0.050美元，空头股息金额为-0.050美元。
                如果您在除息日前一天(10月10日)收盘时持有1标准手的SPXUSD多头仓位（买入），则股息调整的计算如下：
              </p>
              <p class="QA-li ">
                股息调整 = 1（标准手） × 100（合约规格） ×
                0.050美元（多头股息金额） = 5美元
                在除息日的在除息日的00:00-01:00（MT
                时间），5美元将存入您的MT4/MT5账号，备注为“Dividend”。
              </p>
              <p class="QA-li">
                如果您持有空头仓位（卖出），5美元将从您的MT4/MT5账号中扣除，备注为“Dividend”。
              </p>
            </div>
          </div>
          <div class="QA-item">
            <div class="QA-title word33">6、注意事项</div>
            <div class="QA-content">
              <p class="QA-li word34">股息调整适用于指数、ETF和股票类差价合约。</p>
              <p class="QA-li">
                调整金额依据除息日的派息数据、持仓方向和交易手数自动计算并处理。
              </p>
              <p class="QA-li">
                ETF差价合约的股息金额由其对应基金官方公告决定，可能因标的资产变化而波动。
              </p>
              <p class="QA-li">
                股息调整不会改变持仓的点差或交易成本，但会影响账户净值和余额。
              </p>
              <p class="QA-li">
                如需了解特定ETF或指数的除息安排，建议您查看我们的[股息调整明细]或联系您的客户经理。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <page-footer></page-footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import fadeAnimate from "../mixins/fadeAnimate.js";

export default {
    mixins: [fadeAnimate],
  data() {
    return {
      tab: this.$t('Dividend.list'),
      data: [],
    }
  },
  created() {
    this.$http('/ebc/api/getCfd/run').then(async (res) => {
      console.log("data", res.data.data)
      this.data = res.data.data
      await this.$nextTick()
      this.setTable()
    })

  },
  computed: {
    ...mapGetters([
      'signupUrl',
    ])
  },
  methods: {
    setTable(){
        
        if (window.matchMedia("(max-width: 996px)").matches) return;
        const tbody = document.querySelector(".dividend-adjust_tbody");
        if (!tbody) return;
        const cells = [...tbody.querySelectorAll(".dividend-adjust_td")];
        const rowCount = cells.length / 4;
        let lastDate = "",
          startIdx = 0,
          span = 1;

        for (let i = 0; i < rowCount; i++) {
          const dateCell = cells[i * 4 + 3];
          const date = dateCell.textContent.trim();

          if (date === lastDate) {
            dateCell.style.display = "none";
            span++;
          } else {
            handleGroup(startIdx, span);
            lastDate = date;
            startIdx = i;
            span = 1;
          }
        }
        handleGroup(startIdx, span);

        function handleGroup(start, cnt) {
          if (cnt === 0) return;
          const cell = cells[start * 4 + 3];
          cell.style.gridRow = `span ${cnt}`;
          if (start + cnt === rowCount) {
            cell.classList.add("is-last");
          }
        }

        (() => {
          const tbody = document.querySelector(".dividend-adjust_tbody");
          const cells = [...tbody.children];

          /* ----- 1. 建立映射 ----- */
          const rowToGroupStart = [];
          let start = 0;
          for (let i = 0; i < cells.length; i += 4) {
            const hidden = getComputedStyle(cells[i + 3]).display === "none";
            if (!hidden) start = i / 4;
            rowToGroupStart.push(start);
          }

          let lastGroup = -2; // 记录当前高亮的组
          function clearHover() {
            cells.forEach((c) => c.classList.remove("hover"));
          }
          let lastRow = -1;
          tbody.addEventListener("mouseover", (e) => {
            const td = e.target.closest(".dividend-adjust_td");
            if (!td) return;
            const idx = cells.indexOf(td);
            const row = Math.floor(idx / 4);
            const col = idx % 4;
            const grp = rowToGroupStart[row];

            /* ---- 前 3 列：只要换行就重绘 ---- */
            if (col !== 3) {
              if (row === lastRow && col < 3) return; // 同一行内左右动，不重复画
              clearHover();
              lastRow = row;
              /* 画当前行 4 格（日期用首行可见格） */
              for (let c = 0; c < 3; c++) cells[row * 4 + c]?.classList.add("hover");
              cells[rowToGroupStart[row] * 4 + 3]?.classList.add("hover");
              lastGroup = -2; // 清组缓存，防止合并列逻辑误判
              return;
            }

            /* ---- 合并列：按组重绘 ---- */
            if (grp === lastGroup) return; // 同一组内不动
            clearHover();
            lastGroup = grp;
            lastRow = -1; // 清行缓存
            for (let r = 0; r < rowToGroupStart.length; r++) {
              if (rowToGroupStart[r] === grp) {
                for (let c = 0; c < 3; c++) cells[r * 4 + c]?.classList.add("hover");
              }
            }
            cells[grp * 4 + 3]?.classList.add("hover");
          });
        })();
    },
    initPage() {
      const link = document.querySelector(
        'link[href*="/ebc-static/css/bootstrap.css"]'
      );
      if (link) {
        link.remove();
      }


      function syncFakeScroll(wrapperSel) {
        const wrap = document.querySelector(wrapperSel);
        const scroll = wrap.querySelector(".dividend-adjust_table");
        const innerTable = wrap.querySelector(".dividend-adjust_table");
        const track = wrap.querySelector(".fake-scrollbar");
        const thumb = wrap.querySelector(".fake-thumb");

        function sync() {
          const w = scroll.clientWidth;
          const sw = scroll.scrollWidth;
          const l = scroll.scrollLeft;
          const maxL = sw - w;
          if (maxL <= 0) {
            thumb.style.width = "100%";
            return;
          }

          const thumbW = (w / sw) * track.clientWidth;
          thumb.style.width = thumbW + "px";
          const maxMove = track.clientWidth - thumbW;
          thumb.style.transform = `translateX(${(l / maxL) * maxMove}px)`;
          if (l <= 0) {
            wrap.classList.add("noScroll");
          } else {
            wrap.classList.remove("noScroll");
          }
        }
        if (location.href.includes("/ar/")) {
          sync = function sync() {
            console.log("ar");
            const w = scroll.clientWidth;
            const sw = scroll.scrollWidth;
            const l = scroll.scrollLeft;
            const r = scroll.scrollRight;
            const maxL = sw - w;
            if (maxL <= 0) {
              thumb.style.width = "0px";
              track.style.display = "none";
              wrap.classList.add("noScroll");
              return;
            }

            const thumbW = (w / sw) * track.clientWidth;
            thumb.style.width = thumbW + "px";
            const maxMove = track.clientWidth - thumbW;
            if (l > -2) {
              wrap.classList.add("noScroll");
            } else {
              wrap.classList.remove("noScroll");
            }
            thumb.style.transform = `translateX(${(l / maxL) * maxMove}px)`;
          };
        }

        scroll.addEventListener("scroll", sync, { passive: true });
        const ro = new ResizeObserver((entries) => {
          for (const e of entries) {
            scroll.scrollLeft = 0;
            thumb.style.transform = `translateX(0)`;
            wrap.classList.add("noScroll");
            setTimeout(() => {
              sync();
            });
          }
        });
        ro.observe(innerTable);
        sync();
      }
      // 用法
      syncFakeScroll(".dividend-adjust_tableContainer");

    }
  },
  mounted(){
    this.initPage()
    
  }
}
</script>

<style lang="scss">
@import url("../assets/css/commonQuestion.scss");
</style>
<style scoped>
.contentBox {
  max-width: 1200rem;
  margin-inline: auto;
}

.dividend_header {
  background: #ebebeb;
  padding-top: 0rem;
  min-height: 560rem;
  gap: 14rem;
  padding-left: calc(50vw - 600rem);
  position: relative;
  
}
.dividend_main {
  padding-top: 160rem;
  flex: 0 0 588rem;
}

.dividend_title {}

.dividend_desc {
  color: var(--ebc-text-secondary);
  margin: 24rem 0 64rem;
}

.dividend_btn {
  width: fit-content;
  min-width: 180rem;
}

.dividend_model {
  height: 560rem;
  position: absolute;
  left: 50vw;
}

.icon-right {
  display: inline-block;
  margin-left: 5rem;
}

@media (min-width:996px) {
  .ar .dividend_header {
    padding-left: 0;
    padding-right: calc(50vw - 600rem);
  }

  .mn h1,
  .vi h1 {
    font-size: 68rem;
    line-height: 73rem;
  }

  .hi h1 {
    font-size: 77rem;
  }

  .th h1 {
    font-size: 73rem;
  }

  .en h1,
  .es h1 {
    font-size: 70rem;
  }

  .es .dividend_main {
    flex: 0 0 728rem;

  }

  .en .dividend_main {
    flex: 0 0 758rem;
  }

  .es .dividend_header {
    gap: 67rem;

  }

  .en .dividend_header {
    gap: 37rem;
  }
}

@media screen and (max-width: 996px) {
  .contentBox {
    max-width: 100%;
  }

  #page-navigate {
    background: #fff !important;
  }

  .dividend_header {
    flex-direction: column;
    gap: 0;
    align-items: center;
    padding: 0 32rem 80rem;
    overflow: hidden;
  }

    .dividend_main {
    order: 2;
    text-align: center;
    padding-top: 0rem;
    margin-top: -60rem;
    flex-basis: unset;
    width: 100%;
  }
  .dividend_model {
    height: 760rem;
    position: relative;
    left: -210rem;
    max-width: unset;
  }

  .dividend_desc {
    margin: 16rem 0 64rem;
  }

  .dividend_btn {
    width: 100%;
    gap: 8rem;
  }
}

.dividend-adjust {
  padding: 120rem 0;
  background: #fff;
}

div.dividend-adjust_headerList {
  gap: 24rem;
  align-items: unset;
}

.dividend-adjust_headerItem {
  border-radius: var(--ebc-corner-radius-rc16);
  background: var(--ebc-neutral-bg_b);
  padding: 32rem 24rem;
  flex: 1;
}

.dividend-adjust_headerItem svg {
  width: 40rem;
}

.dividend-adjust_headerTitle {
  margin: 16rem 0;
}

.dividend-adjust_headerDesc {
  color: var(--ebc-text-secondary);
}

.dividend-adjust_title {
  margin: 120rem 0 16rem;
}

.dividend-adjust_desc {
  margin-bottom: 60rem;
  color: var(--ebc-text-secondary)
}

.dividend-adjust_th,
.dividend-adjust_td {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24rem;
}

.dividend-adjust_th {
  background: var(--ebc-neutral-bg_c);
}

.dividend-adjust_th:first-child {
  border-top-left-radius: var(--ebc-corner-radius-rc16);
  border: 1px solid rgba(0, 0, 0, .12);
}

.dividend-adjust_th:last-child {
  border-top-right-radius: var(--ebc-corner-radius-rc16);
}

.dividend-adjust_thead,
.dividend-adjust_tbody {
  display: grid;
  grid-template-columns: 1fr 1fr 400rem 1fr;
  align-items: center;
}

.dividend-adjust_td:nth-child(4n+1) {
  border-left: 1px solid rgba(0, 0, 0, .12);
}

.dividend-adjust_td {
  border-right: 1px solid rgba(0, 0, 0, .12);
  border-bottom: 1px solid rgba(0, 0, 0, .12);
  height: 100%;
}

.dividend-adjust_td:nth-child(4n) {
  color: var(--ebc-basecolor-active-500);
}

.dividend-adjust_td:nth-last-child(4) {
  border-bottom-left-radius: var(--ebc-corner-radius-rc16);
}

.dividend-adjust_td.is-last,
.dividend-adjust_td:last-child {
  border-bottom-right-radius: var(--ebc-corner-radius-rc16)
}

.dividend-adjust_th {
  border: 1px solid rgba(0, 0, 0, .12);
  border-left: 0;
  flex: 1;
}

dividend-adjust_table {
  width: 100%;
}

.dividend-adjust_td.hover {
  background: var(--ebc-neutral-bg_b);
}

.dividend-adjust_btn {
  width: fit-content;
  margin: 60rem auto 0;
  display: block;
}

.dividend-adjust_btn>div {
  min-width: 180rem;

}

.ar .dividend-adjust_th:first-child {
  border-top-right-radius: var(--ebc-corner-radius-rc16);
  border-top-left-radius: 0;
  border: 1px solid rgba(0, 0, 0, .12);
  border-left: 0;
}

.ar .dividend-adjust_td:nth-child(4n) {
  border-left: 1px solid rgba(0, 0, 0, .12);
}

.ar .dividend-adjust_td:nth-child(4n+1) {
  border-left: 0;
}

.dividend-adjust_td:last-child {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: var(--ebc-corner-radius-rc16);
}

.ar .dividend-adjust_td:last-child,
.ar .dividend-adjust_td.is-last {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: var(--ebc-corner-radius-rc16);
}

.ar .dividend-adjust_td:nth-last-child(4) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: var(--ebc-corner-radius-rc16);
}

.ar .dividend-adjust_th:last-child {
  border-top-left-radius: var(--ebc-corner-radius-rc16);
  border-top-right-radius: 0;
  border: 1px solid rgba(0, 0, 0, .12);
}

@media (max-width:996px) {
  html {
    height: auto !important;
    min-height: auto !important;
  }

  .ar .dividend-adjust_td:nth-last-child(4) {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    border-top-left-radius: var(--ebc-corner-radius-rc16);
    border-left: 1px solid rgba(0, 0, 0, .12);
  }

  .ar .dividend-adjust_td:nth-last-child(-n+3) {
    border-left: 1px solid rgba(0, 0, 0, .12);
  }

  .ar .dividend-adjust_td:nth-child(4n) {
    border-left: 0;
  }

  .ar .dividend-adjust_th:last-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: var(--ebc-corner-radius-rc16);
    border-top: 0;
    border-left: 0;
  }

  .ar .dividend-adjust_td:last-child {
    border-left: 1px solid rgba(0, 0, 0, .12);
  }

  .ar .dividend-adjust_thead>div {
    border-left: 0;
  }

  .ar .corner-mask {
    left: unset;
    right: -15rem;
  }




  .ar .dividend-adjust_th::after {
    right: unset;
    left: -3px;
    background: linear-gradient(to left, rgba(0, 0, 0, 0.04), transparent);
  }

  .dividend-adjust {
    padding: 80rem 32rem 200rem;
  }

  .dividend-adjust_headerList {
    gap: 32rem;
    flex-wrap: wrap;
  }

  .dividend-adjust_headerItem {
    flex: 0 0 680rem;
    border-radius: 32rem;
    padding: 32rem;
  }

  .dividend-adjust_headerItem svg {
    width: 64rem;
  }

  .dividend-adjust_headerTitle {
    margin: 32rem 0 16rem;
  }

  .dividend-adjust_title {
    margin: 160rem 0 16rem;
  }

  .dividend-adjust_desc {
    margin-bottom: 40rem;
  }

  .dividend-adjust_table {
    display: flex;
    overflow-x: auto !important;
    /* position: relative; */
  }

  .dividend-adjust_table::-webkit-scrollbar {
    display: none;
  }

  .dividend-adjust_thead {
    display: flex;
    flex-direction: column;
    position: sticky;
    left: 0;
    z-index: 3;
  }

  .ar .dividend-adjust_table {
    padding-right: 150px;
  }

  .ar .dividend-adjust_thead {
    position: absolute;
    left: unset;
    right: 0;
    width: 150px;
  }

  .dividend-adjust_thead>div {
    flex: 0 0 140rem;
    width: 100%;
    white-space: nowrap;
    min-width: 204rem;
    padding-inline: 32rem;
  }

  .dividend-adjust_tbody {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    max-height: 570rem;
  }

  .dividend-adjust_tbody>div {
    flex: 0 0 140rem;
    white-space: nowrap;
    padding-inline: 32rem;
    min-width: 240rem;
  }

  .dividend-adjust_thead>div:first-child {
    border: 1px solid rgba(0, 0, 0, .12);
  }

  .dividend-adjust_thead>div:last-child {
    border-top-right-radius: 0;
    border-bottom-left-radius: var(--ebc-corner-radius-rc16);
  }

  .dividend-adjust_thead>div {
    border: 1px solid rgba(0, 0, 0, .12);
    border-top: 0;
  }

  .dividend-adjust_tbody>div:nth-child(4n+1) {
    border: 1px solid rgba(0, 0, 0, .12);
    border-left: 0;
  }

  .dividend-adjust_tbody>div:nth-child(4n+2),
  .dividend-adjust_tbody>div:nth-child(4n+3),
  .dividend-adjust_tbody>div:nth-child(4n+4) {
    border: 1px solid rgba(0, 0, 0, .12);
    border-left: 0;
    border-top: 0
  }

  .dividend-adjust_td:nth-last-child(4) {
    border-bottom-left-radius: 0;
    border-top-right-radius: var(--ebc-corner-radius-rc16);
  }

  .dividend-adjust_tableContainer {
    position: relative;
  }

  .corner-mask {
    position: absolute;
    left: -15rem;
    width: 25px;
    height: 100%;
    background: #fff;
    z-index: 2;
    pointer-events: none;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }

  /* 伪滚动条容器 */
  .fake-scrollbar {
    position: absolute;
    left: 0rem;
    right: 0rem;
    bottom: -40rem;
    height: 4px;
    background: rgba(0, 0, 0, .1);
    border-radius: 2px;
    pointer-events: none;
    /* 只看不点 */
  }

  /* 伪滑块 */
  .fake-thumb {
    height: 100%;
    background: rgba(0, 0, 0, .4);
    border-radius: 2px;
    width: 0;
    /* js 动态算 */
    transition: width .2s;
  }

  .dividend-adjust_btn>div {
    height: 80rem;
    margin: 80rem 0;
    font-size: 28rem;
  }

  .dividend-adjust_th::after {
    content: '';
    position: absolute;
    top: 0;
    right: -8px;
    width: 8px;
    height: 100%;
    background: linear-gradient(to right, rgba(0, 0, 0, 0.04), transparent);
    pointer-events: none;
  }

  .noScroll .dividend-adjust_th::after {
    display: none;
  }
}


</style>